import { render } from "./HelloWorld.vue?vue&type=template&id=b8f11538"
import script from "./HelloWorld.vue?vue&type=script&nonce=HelloWorld&lang=js"
export * from "./HelloWorld.vue?vue&type=script&nonce=HelloWorld&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__